// extracted by mini-css-extract-plugin
module.exports = {"updateButton":"UpdateTimeZoneButton_updateButton__1M0TQ"};